import { FeatureService } from "@Api/FeatureService";
import { AxiosResponse } from "axios";

export class Feature
{
	static AddToCartIsModal = async (): Promise<boolean> =>
	{
		const featureService = new FeatureService();
		const request = await featureService.AddToCartIsModal() as AxiosResponse;
		const isModal: boolean = request.data;
		return isModal;
	};

	static IsSeason = (): boolean =>
	{
		const laborDay = Feature.GetLaborDayDate(new Date().getFullYear());
		const halloween = new Date(new Date().getFullYear(), 9, 31);
		const currentDate = new Date();

		//Add a day to halloween to set up the comparison and avoid messy <= logic
		halloween.setDate(halloween.getDate() + 1);

		// if the current date is after labor day and on or before halloween, we are in season.
		return currentDate > laborDay && currentDate < halloween;
	};

	private static GetLaborDayDate(year: number): Date
	{
		//Date is zero based
		const laborDay = new Date(year, 8, 1); // Set to September 1st of the year
		const dayOfWeek = laborDay.getDay(); // Get the day of the week (0 for Sunday, 1 for Monday, etc.)

		// Calculate the number of days to reach first Monday of September
		// Checks if 9/1 is a Sunday or Monday. If it is we need to find out how many days to add to reach labor day by subtracting the day of the week from 1
		// If 9/1 is a Tuesday or later we need to subtract 8 from the day of the week to get the number we need.
		const daysToAdd = dayOfWeek <= 1 ? 1 - dayOfWeek : 8 - dayOfWeek;

		// Add the days from the last result to determine labor day.
		laborDay.setDate(1 + daysToAdd);

		return laborDay;
	}
}